var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nx-signing-modal-method-p12"},[_c('h4',[_vm._v(_vm._s(_vm.$t('DigestInformation')))]),_c('h5',{staticClass:"mt-4"},[_vm._v(_vm._s(_vm.$t('PleaseWait')))]),_c('p',{staticClass:"mt-4"},[_c('b-spinner')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }